import React from 'react'
import Button from '../../../ui/Button/Button'
import Field from '../../../ui/Field/Field'
import {
  GIFT_FUND_GROUP_FILTER_ALL,
  GIFT_FUND_STATUS_FILTER,
  GIFT_FUND_TYPE_FILTER,
} from './filterGiftFundItems'
import styles from './GiftsFund.module.scss'

const TYPE_OPTIONS = [
  { value: GIFT_FUND_TYPE_FILTER.all, label: 'Усі' },
  { value: GIFT_FUND_TYPE_FILTER.custom, label: 'Власна позиція' },
  { value: GIFT_FUND_TYPE_FILTER.catalog, label: 'Із каталогу' },
]

const STATUS_OPTIONS = [
  { value: GIFT_FUND_STATUS_FILTER.all, label: 'Усі' },
  { value: GIFT_FUND_STATUS_FILTER.active, label: 'Активні' },
  { value: GIFT_FUND_STATUS_FILTER.inactive, label: 'Неактивні' },
]

export const FilterGroup = ({ label, value, options, onChange }) => {
  return (
    <div className={styles.filtersGroup}>
      <span className={styles.filtersLabel}>{label}</span>
      <div className={styles.filtersOptions}>
        {options.map((option) => {
          const isActive = option.value === value
          return (
            <Button
              key={option.value}
              title={option.label}
              theme="solid"
              fill={isActive ? 'accent' : 'normal'}
              size={32}
              onClick={() => onChange(option.value)}
            />
          )
        })}
      </div>
    </div>
  )
}

export const FilterSearch = ({ value, onChange }) => (
  <div className={styles.searchGroup}>
    <span className={styles.filtersLabel}>Пошук</span>
    <div className={styles.searchField}>
      <Field
        fieldType="input"
        config={{ label: 'Назва або код', type: 'text', placeholder: 'Назва або код' }}
        value={value}
        changed={(event) => onChange(event.target.value)}
        isChangable
      />
    </div>
  </div>
)

function GiftsFundTableFilters({
  typeFilter,
  groupFilter,
  statusFilter,
  searchQuery,
  groupOptions,
  onChange,
}) {
  return (
    <div className={styles.filters}>
      <FilterSearch value={searchQuery} onChange={(next) => onChange({ searchQuery: next })} />
      <FilterGroup
        label="Тип"
        value={typeFilter}
        options={TYPE_OPTIONS}
        onChange={(next) => onChange({ typeFilter: next })}
      />
      <FilterGroup
        label="Група"
        value={groupFilter}
        options={groupOptions}
        onChange={(next) => onChange({ groupFilter: next })}
      />
      <FilterGroup
        label="Статус"
        value={statusFilter}
        options={STATUS_OPTIONS}
        onChange={(next) => onChange({ statusFilter: next })}
      />
    </div>
  )
}

export const buildGiftFundGroupFilterOptions = (groups = []) => [
  { value: GIFT_FUND_GROUP_FILTER_ALL, label: 'Усі' },
  ...groups.map((group) => ({
    value: group.id,
    label: group.name || group.id,
  })),
]

export default GiftsFundTableFilters
